import React, { useEffect, useMemo, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";

import { useAppSelector } from "@lib/stores";
import { useAppLiveQuery } from "@modules/local/hooks";
import { db } from "@modules/local/db";
import ButtonTabs from "@components/items/display/ButtonTabs";
import { useAppNavigate } from "@utils/hooks/useAppNavigate";
import ContentPageSelector from "./ContentPageSelector";
import ContentComponentSelector from "@modules/content/components";
import { useB2B } from "@modules/content/B2BContext";
import { MyLibraryPage } from "./MyLibraryPage";
import ButtonTabsV2 from "@components/items/display/ButtonTabsV2";

export default function FlowTab() {
  const [params] = useSearchParams();

  const navigate = useAppNavigate();

  const tabId = parseInt(params.get("tabId") || "0");

  const [selectedFlowTabPageId, setSelectedFlowTabPageId] = useState<number>();

  const { b2B } = useB2B();

  const userId = useAppSelector((state) => state.auth.user.id ?? "");

  const { result: flow, isLoading } = useAppLiveQuery(
    () => db.readerFlows.get(userId),
    [userId]
  );

  const flowTab = useMemo(
    () =>
      flow?.tabs?.find(
        (tab) => (b2B?.isB2B ? tab.isB2B : !tab.isB2B) && tab.id === tabId
      ),
    [flow, tabId, b2B?.isB2B]
  );

  const selectedFlowTabPage = flowTab?.pages?.find(
    (p) => p.id === selectedFlowTabPageId
  );

  useEffect(() => {
    setSelectedFlowTabPageId(flowTab?.pages?.[0]?.id);
  }, [flowTab?.id]);

  if (isLoading)
    // TODO: Do loading here
    return null;

  if (!flowTab) {
    if (b2B?.isB2B !== undefined) {
      return (
        <Navigate
          to={`/?tabId=${
            flow?.tabs?.filter((t) => (b2B.isB2B ? t.isB2B : !t.isB2B))[0]
              ?.id || 0
          }`}
        />
      );
    } else {
      return null;
    }
  }

  const renderTabContent = () => {
    if (selectedFlowTabPage) {
      return selectedFlowTabPage.collectionComponentId &&
        selectedFlowTabPage.collectionComponentType ? (
        <ContentPageSelector
          identifier={selectedFlowTabPage.collectionComponentType}
          pageId={selectedFlowTabPage.collectionComponentId}
        />
      ) : (
        <ContentComponentSelector
          identifier={selectedFlowTabPage.componentType ?? ""}
          componentRef={null}
          id={selectedFlowTabPage.componentId}
        />
      );
    }

    return null;
  };

  switch (flowTab.layoutType) {
    case "PG:LAYOUT:LIBRARY":
      return (
        <div className="flex h-full w-full flex-col items-start justify-start p-10 pb-0">
          <MyLibraryPage id={flowTab?.pages?.[0].componentId} />
        </div>
      );
    default:
      return (
        <div className="flex h-full w-full flex-col items-start justify-start pb-0 pt-10 dark:bg-[#010D19]">
          <ButtonTabsV2
            tabs={
              flowTab.pages?.map((page) => ({
                value: page.id + "",
                label: page.name || "",
              })) ?? []
            }
            value={selectedFlowTabPageId + ""}
            onSelect={(value) => {
              setSelectedFlowTabPageId(Number(value));
            }}
          />
          {renderTabContent()}
        </div>
      );
  }

  // return (
  //   {
  //     flowTab.layoutType !== "PG:LAYOUT:LIBRARY" ? (
  //       <ButtonTabs
  //         tabs={
  //           flowTab.pages?.map((page) => ({
  //             content:
  //               page.collectionComponentId && page.collectionComponentType ? (
  //                 <ContentPageSelector
  //                   identifier={page.collectionComponentType}
  //                   pageId={page.collectionComponentId}
  //                 />
  //               ) : (
  //                 <ContentComponentSelector
  //                   identifier={page.componentType ?? ""}
  //                   componentRef={null}
  //                   id={page.componentId}
  //                 />
  //               ),
  //             trigger: page.name ?? "",
  //             value: page.id + "",
  //             onClick: (value) => {
  //               setSelectedFlowTabPage(Number(value));
  //             },
  //           })) ?? []
  //         }
  //         value={selectedFlowTabPage + ""}
  //         contentClassName="flex justify-start items-center"
  //         hideWithSignleItem
  //       />
  //     ) : (
  //       <MyLibraryPage id={flowTab?.pages?.[0].componentId} />
  //     )
  //   }
  // );
}
